<template>
    <div id="linkmanDetail">
      <div v-if="justViewDetail">
        <div class="topRow" v-if="!editMode">
          <pt-tag :text="linkmanVO.isQuit ? $t('linkman.incumbency'):$t('linkman.quit')" type="triangle"></pt-tag>
          <div class="btnsDiv">
            <a-button @click="shareEvent">
              <pt-icon type="icon-gongxiang"></pt-icon>
              {{$t('linkman.detail.share')}}
            </a-button>
            <a-button @click="changeEvent">
              <pt-icon type="icon-renyuanbiandongfenxi"></pt-icon>
              {{$t('linkman.detail.change')}}
            </a-button>
            <a-button @click="editEvent">
              <pt-icon type="icon-bianji1"></pt-icon>
              {{$t('baseVO.edit')}}
            </a-button>
          </div>
        </div>
        <div v-if="editMode" class="btnRow">
          <a-button type="primary" style="margin-right: 10px;" @click.stop="saveEdit">{{$t('baseVO.save')}}</a-button>
          <a-button @click.stop="cancelEdit">{{$t('baseVO.cacel')}}</a-button>
        </div>
      </div>
      <div v-if="!editMode">
        <div class="contactInfo">
          <div class="greyDiv">
            <div style="margin-bottom:10px;display: flex;align-items: center">
              <span class="nameText" v-text="linkmanVO.name"></span>
              <span class="type_tag">
                {{$t('linkman.linkmanType.'+linkmanVO.type)}}
              </span>
            </div>
            <a-row style="margin-bottom:15px;" :gutter="20">
              <a-col :span="8">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.nameEN')}}：</div>
                  <div class="infoText" v-text="linkmanVO.nameEN"></div>
                </div>
              </a-col>
              <a-col :span="8">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.job')}}：</div>
                  <div class="infoText" v-text="linkmanVO.job"></div>
                </div>
              </a-col>
              <a-col :span="8">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.dockingMan')}}：</div>
                  <div class="infoText" v-text="linkmanVO.dockingPartnersName"></div>
                </div>
              </a-col>
            </a-row>
            <a-row style="margin-bottom: 30px;" :gutter="20">
              <a-col :span="8">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.mobilePhone')}}：</div>
                  <div class="infoText" v-text="linkmanVO.phone"></div>
                </div>
              </a-col>
              <a-col :span="8">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.telephone')}}：</div>
                  <div class="infoText" v-text="linkmanVO.seatNumber"></div>
                </div>
              </a-col>
              <a-col :span="8">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.email')}}：</div>
                  <div class="infoText" v-text="linkmanVO.email">1</div>
                </div>
              </a-col>
            </a-row>
            <a-row style="margin-bottom: 15px;" :gutter="20">
              <a-col :span="8">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.company')}}：</div>
                  <div class="infoMaxText" v-text="linkmanVO.companyName"></div>
                </div>
              </a-col>
              <a-col :span="16">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.contactAddress')}}：</div>
                  <div class="infoMaxText" v-text="linkmanVO.address"></div>
                </div>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <div class="infoItem">
                  <div class="infoLabel">{{$t('linkman.modal.remarks')}}：</div>
                  <div class="infoMaxText" v-text="linkmanVO.remarks"></div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
        <div style="padding: 0 40px;">
          <div v-if="modeType == 3">
            <div class="titleRow">
              <div class="circleYellow"></div>
              <div class="titleText">{{$t('linkman.modal.manageProject')}}</div>
            </div>
            <div class="projectsDiv" v-if="linkmanVO.linkmanMansionDOList && linkmanVO.linkmanMansionDOList.length > 0">
              <div v-for="(mansion,index) in linkmanVO.linkmanMansionDOList" class="projectItem">
                <pt-tag size="small" :text="mansion.mansionName" color="grey" style="margin-bottom:10px;"></pt-tag>
              </div>
            </div>
            <div style="width: 100%" v-else>
              <pt-empty></pt-empty>
            </div>
          </div>
          <div>
            <div class="titleRow">
              <div class="circleYellow"></div>
              <div class="titleText">{{$t('linkman.detail.careerExperience')}}</div>
            </div>
            <div style="padding: 20px 30px;" v-if="linkmanChanges && linkmanChanges.length > 0">
              <a-steps direction="vertical" progressDot :current="0">
                <template v-for="(linkmanChange,index) in linkmanChanges">
                  <a-step>
                    <div slot="description">
                      <div>
                        {{linkmanChange.quitDate}}
                      </div>
                      <div>
                        {{linkmanChange.entryLinkmanVO.name}} <span>{{ $t('key86cong') }}</span> {{linkmanChange.quitLinkmanVO.companyName}} <span>{{ $t('key86') }}</span> {{linkmanChange.entryLinkmanVO.companyName}}。
                      </div>
                    </div>
                  </a-step>
                </template>
              </a-steps>
            </div>
            <div style="padding: 20px 30px;" v-else>
              <pt-empty><span slot="description"></span></pt-empty>
            </div>
          </div>
          <div class="authorRow">
            <span>{{$t('linkman.detail.author')}} {{linkmanVO.createName}}</span>
            <span>{{$t('linkman.detail.createTime')}} {{$utils.formatDate(linkmanVO.createTime)}}</span>
          </div>
        </div>
      </div>
      <div v-if="editMode" style="padding: 40px;">
        <add-linkman ref="addLinkman" :modeType="modeType" :linkmanId="linkmanId"  @saveSuccess="saveSuccess"></add-linkman>
      </div>
      <pt-modal :title="$t('linkman.changeModal.title')" :visible="changeModalVisible" :loading="changeModalloading" @ok="handleOk"
                @cancel="handleCancel">
        <div slot="content">
          <linkman-change :linkmanId="linkmanId" :mode-type="modeType" ref="linkmanChange" @saveChangeSuccess="saveChangeSuccess" @error="saveError"></linkman-change>
        </div>
      </pt-modal>
      <pt-select-user :isShare="true" :visible="helperModal.visible" @close="cancelAddHelper" @ok="selectResultEvent"
                      ref="selectUserRef" :title="$t('linkman.modal.shareTitle')"></pt-select-user>
    </div>
</template>

<script>
  import addLinkman from './addLinkman'
  import LinkmanChange from './linkmanChange'
  import {selectOne,saveShare} from '@/api/database/linkman'
  import {queryByLinkmanId} from '@/api/database/linkmanChangeRecords'
  export default {
    name: 'linkmanDetail',
    components:{
      LinkmanChange,
      addLinkman,
    },
    props:{
      justViewDetail:{
        default:true,
        type:Boolean,
      },
      linkmanId:null,
      modeType:{
        type:Number,
        default:1, //1新增客户联系人 2新增同行联系人  3 新增业主联系人
      },
    },
    data(){
      return{
        editMode:false,
        changeModalloading:false,
        changeModalVisible:false,
        linkmanVO:{},//联系人详情
        linkmanChanges:[],//职业经历
        helperModal:{
          visible:false,
        },
        linkmanAccountDOList:[],//分享的人
      }
    },
    mounted(){
      this.init()
    },
    methods:{
      cancelAddHelper(){
        this.helperModal.visible = false;
      },
      selectResultEvent(value){
        this.linkmanAccountDOList = [];
        value.forEach(user=>{
          let linkmanAccountDO = {
            linkmanId:this.linkmanId,
            accountId:user.accountid
          }
          this.linkmanAccountDOList.push(linkmanAccountDO);
        })
        this.submitShare();
      },
      submitShare(){
        saveShare(this.linkmanAccountDOList).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('linkman.modal.shareSuccessTip'));
          }
        })
      },
      getMansionImageUrl(fileId){
        let url = this.$util.getFileUrl(fileId);
        return url;
      },
      init(){
        this.queryDetail();
        this.queryExperience();//查询职业经历
      },
      queryDetail(){
        let this_ = this
        selectOne(this_.linkmanId).then(res=>{
          if(res.code == 1){
            this_.linkmanVO = res.data
          }
        })
      },
      queryExperience(){
        let this_ = this
        queryByLinkmanId(this_.linkmanId).then(res=>{
          if(res.code == 1){
            this_.linkmanChanges = res.data
          }
        })
      },
      shareEvent(){
        this.helperModal.visible = true;
      },
      changeEvent(){
        this.changeModalVisible = true;
      },
      editEvent(){
        this.editMode = true;
      },
      handleOk(){
        if(!this.changeModalloading){
          this.changeModalloading = true;
          this.$refs.linkmanChange.submit();
        }
        //this.changeModalVisible = false;
      },
      saveError(){
        this.changeModalloading = false;
      },
      saveChangeSuccess(){
        this.handleCancel();
        this.$emit("colseLinkman");
      },
      handleCancel(){
        this.changeModalloading = false;
        this.changeModalVisible = false;
      },
      saveSuccess(){
        this.cancelEdit();
        this.queryDetail();
        this.$emit("freshLinkmanList");
      },
      saveEdit(){
        this.$refs.addLinkman.submit();
      },
      cancelEdit(){
        this.editMode = false;
      }
    }
  }
</script>

<style scoped lang="less">
  .ant-steps-dot .ant-steps-item-content{
    width: 400px !important;
  }
  #linkmanDetail{
    display: flex;
    flex-direction: column;
    .topRow{
      height: 50px;
      background: #FAFBFC;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .btnsDiv{
        display: flex;
        flex-direction: row;
        margin-right: 20px;
        .ant-btn{
          margin-right: 15px;
        }
      }
    }
    .btnRow{
      height: 50px;
      background: #FAFBFC;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      padding: 0 40px;
      .ant-btn{
        margin-right: 15px;
      }
    }
    .contactInfo{
      padding: 40px;
    }
    .greyDiv{
      background: #FAFBFC;
      padding:10px 30px;
      .nameText{
        font-size: 24px;
        color: #333333;
      }
    }
    .infoItem{
      display: flex;
      flex-direction: column;
    }
    .infoLabel{
      font-size: 12px;
      color: #999999;
      text-align: left;
    }
    .infoText{
      font-size: 12px;
      color: #333333;
      text-align: left;
    }
    .infoMaxText{
      font-size: 12px;
      color: #333333;
    }
    .remarksDiv{
      margin-left: 45px;
      margin-top: 16px;
      .remarksLabel{
        font-size: 12px;
        color: #999999;
        margin-bottom: 8px;
      }
      .remarksText{
        font-size: 12px;
        color: #333333;
      }
    }
    .titleRow{
      background: #FAFBFC;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 15px;
      .circleYellow{
        width: 12px;
        height: 12px;
        background: #FABE00;
        border-radius: 50%;
        margin: 0 10px;
      }
      .titleText{
        font-size: 14px;
        color: #333333;
        font-weight: bold;
      }
    }
    .projectsDiv{
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 0 15px 20px;
    }
    .authorRow{
      border-top: 1px solid #E7E7E7;
      padding: 10px 0;
      span{
        font-size: 12px;
        color: #999999;
        margin-right: 40px;
      }
    }
    .type_tag{
      background: #efefef;
      display: inline-block;
      padding: 0px 6px;
      position: relative;
      margin-left: 20px;
      color: #666666;
      border-radius: 2px;
      font-size: 14px;
    }
    .type_tag:before{
      content: '';
      display: block;
      position: absolute;
      left: -20px;
      bottom: 0px;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-right-color: #efefef;
    }
  }
</style>